import { ColDef } from 'ag-grid-community';
import DefaultGrid from '../../default-grid/DefaultGrid';

const colDefs: Array<ColDef> = [{
    headerName: "Column 1",
    field: "cell1",
    sortable: true,
    filter: true
}, {
    headerName: "Column 2",
    field: "cell2",
    sortable: true,
    filter: true
}, {
    headerName: "Column 3",
    field: "cell3",
    sortable: true,
    filter: true
}, {
    headerName: "Column 4",
    field: "cell4",
    sortable: true,
    filter: true
}];

const rowData: Array<any> = [{
    cell1: "Row 1 Cell 1",
    cell2: "Row 1 Cell 2",
    cell3: "Row 1 Cell 3",
    cell4: "Row 1 Cell 4"
}, {
    cell1: "Row 2 Cell 1",
    cell2: "Row 2 Cell 2",
    cell3: "Row 2 Cell 3",
    cell4: "Row 2 Cell 4"
}, {
    cell1: "Row 3 Cell 1",
    cell2: "Row 3 Cell 2",
    cell3: "Row 3 Cell 3",
    cell4: "Row 3 Cell 4"
}, {
    cell1: "Row 4 Cell 1",
    cell2: "Row 4 Cell 2",
    cell3: "Row 4 Cell 3",
    cell4: "Row 4 Cell 4"
}];

type SampleGridProps = {
    spacing: number;
    fontSize: number;
};

export function SampleGrid({
    spacing, fontSize
}: SampleGridProps) {
    return (
        <DefaultGrid
            columnDefs={colDefs}
            rowData={rowData}
            spacingOverride={spacing}
            fontSizeOverride={fontSize}
            domLayout="autoHeight"
        />
    );
}
